@if (!hasMessagingNumbers() && !messagingService.getNumbersInProgress() && !hasProcessingNumbers()) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <div class="no-messages-container" style="text-align: center">
              <mat-icon class="icon-40">perm_phone_msg</mat-icon>
              <h2>You haven't added any Pro Business SMS numbers</h2>
              <p>You must enable numbers you'd like to use for Pro Business SMS.</p>
              @if (hasPhoneNumbersEditRight) {
                <div>
                  <button mat-flat-button color="primary" (click)="addNewSmsNumber()">
                    <span class="center-text">Add New Phone Number</span>
                  </button>
                </div>
              } @else {
                <span>Contact your company administrator to setup messaging number.</span>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

@if (!hasMessagingNumbers() && !messagingService.getNumbersInProgress() && hasProcessingNumbers()) {
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <mat-card appearance="outlined" style="margin-top: 30px">
          <mat-card-header></mat-card-header>
          <mat-card-content>
            <div class="no-messages-container" style="text-align: center">
              <mat-icon class="icon-40">perm_phone_msg</mat-icon>
              <h2>Activating SMS service is progress</h2>
              <p>SMS service activation could take up to 12h.</p>
              <div *ngFor="let number of processingNumbers()" fxLayout="row" fxLayoutAlign="center center"
                   fxLayoutGap="5px">
                <span style="font-weight: bold">{{ number.number | phoneNumber }}</span>
                <span>Status: <span style="font-weight: bold">{{ number.smsServiceStatus }}</span></span>
              </div>
              <mat-progress-spinner style="margin: 50px auto" [strokeWidth]="3" mode="indeterminate"
                                    [diameter]="150"></mat-progress-spinner>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
}

@if (hasMessagingNumbers()) {
  <mat-drawer-container #mainContainer class="messaging-container">
    <mat-drawer #threadsDrawer [mode]="sidenavMode()" [opened]="showThreads()" (opened)="onThreadsMenuOpened()"
                [disableClose]="sidenavMode() === 'side'">
      <div class="actions-container">
        @if (isMobileView()) {
          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button class="button-40" (click)="threadsDrawer.close()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
        <app-pro-phone-number-select></app-pro-phone-number-select>

        @if (hasEditAccess && messagingService.selectedMessagingNumber?.allowSend && !limitsReached) {
          <div>
            <button mat-flat-button color="primary" class="compose-btn" (click)="onNewMessage($event)">
              <mat-icon>add_circle</mat-icon>
              Compose A New Message
            </button>
          </div>
        }

        @if (routedPhoneNumber) {
          <mat-form-field class="sms-search-field no-underline" appearance="outline">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput
                   type="text"
                   placeholder="Search message"
                   autocomplete="off"
                   spellcheck="false"
                   role="searchbox"
                   aria-label="Search messages"
                   [ngModel]="searchTextInternal()"
                   (ngModelChange)="searchTextInternal.set($event)"
                   (keyup.escape)="clearSearch()" />
            @if (searchTextInternal()) {
              <a mat-icon-button matSuffix aria-label="Clear" class="button-40"
                 (click)="clearSearch()">
                <mat-icon>close</mat-icon>
              </a>
            }
          </mat-form-field>
        }
      </div>

      <div class="threads-container">
        <app-pro-phone-number-group-v2 #threadCmp
                                       [selectedTheadKey]="routedThreadKey"
                                       [searchText]="searchText()"
                                       [hasContactsEditRight]="hasContactsEditRight"
                                       [hasContactsModule]="hasContactsModule"
                                       [defaultSortType]="smsThreadSortType">
        </app-pro-phone-number-group-v2>
      </div>
    </mat-drawer>
    <mat-drawer-content>
      <form class="messages-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <div class="messages-container" fxLayout="column" [ngClass]="{'is-mobile-view': isMobileView()}">
          <div class="messages-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            @if (isMobileView()) {
              <button mat-icon-button class="button-40 rect-btn active-accent" type="button"
                      (click)="threadsDrawer.toggle()" fxFlexOrder="1">
                <mat-icon>menu_open</mat-icon>
              </button>
            }
            <div fxLayout="row" fxLayoutAlign="start center"
                 fxFlex fxFlex.xs="100" fxFlexOffset.xs="10px"
                 fxLayoutGap="10px" fxFlexOrder="2" fxFlexOrder.xs="3">
              <label>To:</label>
              <app-pro-thread-recipients class="messaging-recipients" formControlName="clientPhoneNumbers" fxFlex
                                         (ngModelChange)="clientPhoneNumbersChanged($event)"
                                         placeholder="Enter phone number"></app-pro-thread-recipients>
            </div>

            @if (hasDeleteAccess && messagingService.selectedMessagingNumber?.allowSend && !!selectedGroup && !!selectedGroup?.threadKey && selectedGroup?.threadKey !== 'new') {
              <button mat-icon-button color="warn" class="button-40 rect-btn active-warn" fxFlexOrder="3"
                      type="button"
                      fxFlexOrder.xs="2"
                      title="Delete Conversation"
                      (click)="onDeleteClick()">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
          <div class="messages-holder" fxFlex>
            <app-pro-messages-grid-v2
              [selectedThreadKey]="routedThreadKey"
              [searchText]="searchText()"
              [selectedGroup]="selectedGroup"
              (lastIncomingMessageEvent)="onLastIncomingMessage($event)">
            </app-pro-messages-grid-v2>
          </div>
          @if (!messagesDatasource.loading() && !messagingService.getNumbersInProgress() && selectedGroup) {
            <div class="messages-actions">
              @if (hasEditAccess && messagingService.selectedMessagingNumber?.allowSend && !selectedGroup?.broadcastId && !limitsReached) {
                <div class="messages-footer">
                  <div class="messages-form" fxLayout="column" fxLayoutGap="10px">
                    @if (previewFileName) {
                      <div class="preview-attachment" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start">
                        <div fxFlex fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                          @if (previewUrl) {
                            <img [src]="previewUrl" alt="preview">
                          }
                          <div>{{ previewFileName }}</div>
                        </div>
                        <button type="button" mat-icon-button class="button-40" (click)="removeAttachment()"
                                matTooltip="Remove attachment">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    }

                    <div class="actions-row" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start"
                         [ngClass]="{'is-mobile-view': isMobileView()}">
                      @if (providerTypes.length > 1) {
                        <button type="button" mat-icon-button class="button-40 rect-btn"
                                [ngClass]="{'message-waba-btn active': form.getRawValue().type === 'waba', 'active-accent': form.getRawValue().type === 'text'}"
                                [matMenuTriggerFor]="messageTypeMenu">
                          @if (form.getRawValue().type === 'text') {
                            <i class="fa-icon fa-solid fa-comment-sms"></i>
                          }
                          @if (form.getRawValue().type === 'waba') {
                            <i class="fa-icon fa-brands fa-whatsapp"></i>
                          }
                        </button>
                      }
                      <mat-menu #messageTypeMenu="matMenu" class="custom-menu">
                        <button type="button" mat-menu-item (click)="selectCommunicationType('text')"
                                fxLayout="row" fxLayoutAlign="start center">
                          <mat-icon fontSet="fas" fontIcon="fa-comment-sms"></mat-icon>
                          SMS/MMS
                        </button>
                        <button type="button" mat-menu-item (click)="selectCommunicationType('waba')"
                                fxLayout="row" fxLayoutAlign="start center">
                          <mat-icon fontSet="fab" fontIcon="fa-whatsapp"></mat-icon>
                          WhatsApp
                        </button>
                      </mat-menu>

                      <input #fileInput id="upload-mms" style="display: none" class="file-input" type="file"
                             (change)="fileChangeEvent($event)"
                             placeholder="Choose a file..." />

                      @if (!canSendMessage()) {
                        <div fxFlex fxLayout="row" fxLayoutAlign="center center">
                          <button type="button" color="primary" mat-stroked-button (click)="onSelectWhatsAppTemplate()"
                                  style="line-height: 38px;">
                            Select Template
                          </button>
                        </div>
                      }

                      <div fxFlex fxLayout="row" fxLayoutAlign="start center"
                           [ngClass]="{'hidden': !canSendMessage()}"
                           [ngStyle]="{'display': canSendMessage() ? 'flex' : 'none'}">

                        <div fxLayout.lt-sm="row wrap" fxFlex fxLayoutAlign.lt-sm="end center" fxLayout="row"
                             fxLayoutAlign="start center">
                          <mat-form-field appearance="outline" fxFlex fxFlex.lt-sm="100" class="message-text-field">
                            <textarea #textInput
                                      matInput
                                      [cdkTextareaAutosize]="true"
                                      [cdkAutosizeMinRows]="1"
                                      [cdkAutosizeMaxRows]="5"
                                      formControlName="message"
                                      (paste)="onFilePaste($event)" (focus)="markUnreadMessages()"
                                      (keypress)="msgKeyPress($event)" placeholder="Enter your message">
                            </textarea>
                          </mat-form-field>

                          <button mat-icon-button type="button" class="button-40" (click)="fileInput.click()"
                                  fxLayout="row">
                            <mat-icon>attach_file</mat-icon>
                          </button>

                          <button mat-icon-button type="button" class="button-40" (click)="templateTrigger.click()"
                                  fxLayout="row">
                            <mat-icon>quickreply</mat-icon>
                            <app-messaging-select-template-v2 #templateTrigger
                                                              style="visibility: hidden; height: 1px; width: 1px; position: absolute"
                                                              (selectedEvent)="onTemplateSelected($event)"></app-messaging-select-template-v2>
                          </button>

                          @if (form.getRawValue().type === 'waba') {
                            <button mat-icon-button type="button" class="button-40" fxLayout="row"
                                    (click)="onSelectWhatsAppTemplate()">
                              <i class="fa-icon fa-brands fa-whatsapp"></i>
                            </button>
                          }
                        </div>
                      </div>
                      <button type="submit" mat-icon-button class="button-40 rect-btn message-send-btn active"
                              color="primary"
                              matTooltip="Send Message">
                        @if (!submitting) {
                          <mat-icon>send</mat-icon>
                        } @else {
                          <mat-spinner diameter="24" strokeWidth="2"></mat-spinner>
                        }
                      </button>
                    </div>
                  </div>
                  <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
                    <div>Drop File Here</div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </form>
    </mat-drawer-content>
  </mat-drawer-container>
}
